import { Col, Space } from "antd";

export const Labels = () => {
  return (
    <Col span={3} style={{ minWidth: "180px" }}>
      <Space align="end" direction="vertical">
        <Col>Für Abfrage relevant:</Col>
        <Col>Unschärfe zulassen:</Col>
        <Col>uID:</Col>
        <Col style={{ paddingTop: "5px" }}>Merkmal:</Col>
        <Col style={{ paddingTop: "5px" }}>Abfragephrase:</Col>
      </Space>
    </Col>
  );
};
